import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateTheme, updateFontSize } from '../../actions';
import styled from 'styled-components';
import { Button } from '@blueprintjs/core';
import { DARK_THEME, LIGHT_THEME, FONT_INCREMENT } from '../../constants';


const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

class SubtitleStyleControls extends React.Component {

  toggleTheme = () => {
    const {theme} = this.props;
    const newTheme = theme === DARK_THEME ? LIGHT_THEME : DARK_THEME;
    this.props.updateTheme(newTheme);
  };

  zoomOut = () => {
    this.props.updateFontSize(this.props.fontSize - FONT_INCREMENT);
  };

  zoomIn = () => {
    this.props.updateFontSize(this.props.fontSize + FONT_INCREMENT);
  };

  render() {

    const {theme} = this.props;

    return (
      <Container>
        <Button className="pt-minimal"
                onClick={this.toggleTheme}
                icon={theme === DARK_THEME ? "flash" : "moon"}
        />
        <Button className="pt-minimal"
                onClick={this.zoomOut}
                icon="zoom-out"
        />
        <Button className="pt-minimal"
                onClick={this.zoomIn}
                icon="zoom-in"
        />
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    theme: state.theme,
    fontSize: state.fontSize
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateTheme,
    updateFontSize
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SubtitleStyleControls);



// WEBPACK FOOTER //
// ./src/containers/SubtitlesStyleControls/index.js